const SCHEDULE_TIME = {
    MORNING: 'MORNING',
    AFTERNOON: 'AFTERNOON',
    EVENING: 'EVENING',
};

export default SCHEDULE_TIME;
